import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import htmlSerializer from '../../utils/htmlSerializer';
import Carousel from './Carousel';
import { Styled } from './CarouselWrapper.styles';
const CarouselWrapper = ({ onClose, onURLButtonClick, value, }) => {
    const [activeCard, setActiveCard] = useState(0);
    const onPageChange = ({ card }) => setActiveCard(card);
    const handleNextPage = () => setActiveCard(activeCard + 1);
    return (_jsx(Carousel, { activeCard: activeCard, onPageChange: onPageChange, onArrowClick: onPageChange, children: value.map((card, index) => {
            const container = (_jsx(Styled.CardContainer, { children: card.map((content, index) => {
                    const component = htmlSerializer({
                        content,
                        onClose,
                        handleNextPage,
                        onURLButtonClick,
                        key: `card-${index}-content-${index}`,
                    });
                    return component;
                }) }, `card-${index}`));
            return container;
        }) }));
};
export default CarouselWrapper;
//# sourceMappingURL=CarouselWrapper.js.map